import React, { useEffect, useState } from "react";
import { Alert, Empty, Modal, Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { translate } from "../../locale";
import SubscriptionServices from "../../services/SubscriptionServices";
import PropTypes from "prop-types";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const ModalLinkHistory = ({ visible, subscription, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [filteredData, setFilteredData] = useState(null);

  const columns = [
    {
      title: translate("Hora"),
      dataIndex: "time",
      key: "time",
    },
    {
      title: translate("Fecha"),
      dataIndex: "date",
      key: "date",
    },
    {
      title: translate("Link"),
      dataIndex: "url",
      key: "url",
    },
    {
      title: translate("Responsable de edición"),
      dataIndex: "full_name",
      key: "full_name",
    },
  ];

  useEffect(() => {
    console.log("subscription", subscription);
  }, []);

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true) {
        loadData();
      }
    }
  }, [visible]);

  const loadData = async () => {
    try {
      const response = await SubscriptionServices.getExternalLink(
        subscription.enterprise_id,
        subscription.id,
      );

      if (
        response.status >= 200 &&
        response.status < 300 &&
        response.data.data[0] != undefined
      ) {
        const newData = response.data.data[0].history.map((i) => ({
          ...i,
          full_name: `${i.first_name} ${i.last_name}`,
        }));
        setFilteredData(newData);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Modal
      open={active}
      title={translate("Registro de modificaciones")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
      width={"80%"}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      <Table
        dataSource={filteredData}
        columns={columns}
        loading={
          loading && { indicator: antIcon, className: "text-custom_blue" }
        }
        rowKey={(i) => i.id}
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
      />
    </Modal>
  );
};

ModalLinkHistory.propTypes = {
  visible: PropTypes.bool.isRequired,
  subscription: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ModalLinkHistory;
